import React from 'react';
import styled, {useTheme} from 'styled-components';
import PropTypes from "prop-types";

const Holder = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  width: 100%;
  grid-gap: 2px;
  button {
    width: 100%;
    height: 0;
    padding-bottom: 100%;
    border-radius: 50%;
    background-color: var(--color);
  }
`;

function ColorButtons(props) {
  const theme = useTheme()

  const colors = Object.keys(theme.colors);

  return (
    <Holder>
      {colors.map((keyName, i) => (
        <button key={i} className={keyName} style={{'--color': theme.colors[keyName]}} onClick={() => props.clickHandler('color', keyName)}/>
      ))}
    </Holder>
  )
}

ColorButtons.propTypes = {
  clickHandler: PropTypes.func.isRequired,
};

export default ColorButtons;